<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公告编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-top: 40px;">
      <el-form label-width="80px" ref="model" :model="model">
        <el-form-item label="标题" prop="userName">
          <el-input v-model="model.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="userName">
          <vue-editor v-model="model.info"></vue-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!pageStutas">
        <el-button size="big" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button size="big" type="primary" :loading="loading" class="title" @click="editForm()">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {VueEditor, Quill} from "vue2-editor";
import { loadNote, deptSave } from '../../api/userMG'
export default {
  name: 'Tinymce',
  components:{
    VueEditor
  },
  data() {
    return {
      loading: false,
      pageStutas: false,
      model:{
        title: '',
        info: ''
      }
    }
  },
  created() {
    console.log(this.$route.query.goData);
    if(this.$route.query.goData) {
      this.pageStutas = true;
      this.model.title = this.$route.query.goData.title;
      this.model.info = this.$route.query.goData.info;
    }else{
      this.pageStutas = false;
    }
    
  },
  methods: {
    submitForm() {
      this.loading = true;
      loadNote(this.model)
        .then(res => {
          this.loading = false
          if (res.success) {
            this.model.title = '';
            this.model.info = '';
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
      })
    },
    editForm () {
      this.loading = true;
      loadNote({noteId:this.$route.query.goData.id,title:this.model.title,info:this.model.info})
        .then(res => {
          this.loading = false
          if (res.success) {
            this.model.title = '';
            this.model.info = '';
            this.$message({
              type: 'success',
              message: '数据编辑成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('编辑失败，请稍后再试！')
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.editor-custom-btn-container {
  position: absolute;
  right: 100px;
  top: 100px;
  /*z-index: 2005;*/
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
}
.dialog-footer{
  margin-left: 80px;
  margin-top: 40px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/adminSet/noteAddSet.vue